// Author Lin
// Date 2023-08-11 08:42:03

import * as model from "@/model/sithMes/prd/SithMesPrdKamChangeModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesPrdKamChange(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_PRD_URL,
        callbackApi: process.env.VUE_APP_SITHMES_PRD_URL + '/sithMesPrdKamChange/workflow/complete-feedback',
        processDefinitionKey: "prd_kam_change",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .buildStore()
